import './solutionPremiumRoutes.styles';
import React from 'react';
import CROHeroSection from '../components/hero/CROHeroSection';
import SolutionPageLayout from '../components/premium/SolutionPageLayout';
import { solutionCroConfig } from '../data/solutionContent';

const SolutionCRO: React.FC = () => (
  <SolutionPageLayout hero={<CROHeroSection />} config={solutionCroConfig} />
);

export default SolutionCRO;
